import { ThemeService } from '@services/theme/theme.service';
import { UiService } from '@services/ui/ui.service';
import { LabelsService } from '@services/labels/labels.service';
import { AuthService } from '@services/auth/auth.service';
import { Injectable } from '@angular/core';
import { IdleService } from '@services/idle/idle.service';
import { ContentService } from '@services/content/content.service';
import { register } from 'swiper/element/bundle';
import { PushNotificationsService } from '@services/push-notifications/push-notifications.service';
import { NetworkStateService } from '@services/network-state/network-state.service';
import { StorageService } from '@services/storage/storage.service';
import { NavigatorService } from '@services/navigator/navigator.service';
import { InfrastructureService } from '@services/infrastructure/infrastructure.service';
import { BootstrapHookService } from '@services/hooks/bootstrap-hook/bootstrap-hook.service';

// https://ionicframework.com/docs/angular/slides#getting-started
register();

@Injectable({
  providedIn: 'root'
})
export class BootstrapService {
  constructor(
    private authService: AuthService,
    private labels: LabelsService,
    private uiService: UiService,
    private themeService: ThemeService,
    private networkStateService: NetworkStateService,
    private idleService: IdleService,
    private contentService: ContentService,
    private pushNotificationsService: PushNotificationsService,
    private storageService: StorageService,
    private infrastructureService: InfrastructureService,
    private navigatorService: NavigatorService,
    private bootstrapHookService: BootstrapHookService
  ) {}

  async bootstrap(): Promise<void> {
    await this.bootstrapHookService.beforeBootstrap();

    this.labels.loadOpenLabels().subscribe();
    this.authService.addActionAfterLogon(this.labels.loadLabels());
    this.authService.addActionAfterLogon(() =>
      this.themeService.setCompanyTheme()
    );
    this.uiService.ensureFullscreen();
    this.uiService.ensureOverlayClosingOnPageChange();
    this.networkStateService.listenConnectionLoss();
    this.idleService.listenIdle();
    this.contentService.listenContentPage();
    this.contentService.listenNavigationEnd();

    await this.pushNotificationsService.init();
    await this.storageService.init();

    await this.checkInfrastructure();

    await this.bootstrapHookService.afterBootstrap();
  }

  private async checkInfrastructure(): Promise<void> {
    const checks = await this.infrastructureService.getInfrastructureChecks();

    if (!checks.systemAvailable) {
      await this.navigatorService.navigateToMaintenance();
    } else if (!checks.versionAllowed) {
      await this.navigatorService.navigateToUpdateRequired();
    }
  }
}
